import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  Sheet,
  SheetBody,
  SheetContent,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import clsx from "clsx"
import { NavArrowLeft } from "iconoir-react"
import { useState } from "react"

import { usePgCTLOfferLetter } from "../usePgCTLOfferLetter"
import Animation from "./animation"
import AiTools from "./Steps/AiTools"
import BuildCareer from "./Steps/BuildCareer"
import CurrentStepIndicator from "./Steps/CurrentStepIndicator"
import GetStartedStep from "./Steps/GetStartedStep"
import WhatNext from "./Steps/WhatNext"

export enum OnboardingStepId {
  getStarted = "get-started",
  buildCareer = "build-career",
  aiTools = "ai-tools",
  whatNext = "what-next",
}

const steps = [
  { id: OnboardingStepId.getStarted, component: GetStartedStep },
  { id: OnboardingStepId.buildCareer, component: BuildCareer },
  { id: OnboardingStepId.aiTools, component: AiTools },
  { id: OnboardingStepId.whatNext, component: WhatNext },
]
const PgCTLWelcomeOnboardingDialog = () => {
  const { offerLetter, markViewed } = usePgCTLOfferLetter()
  const [openDialog, setOpenDialog] = useState(true)

  const isSmDown = useMediaQuery("only screen and (max-width : 640px)")
  const [animationDirection, setAnimationDirection] = useState(1)
  const [currentStep, setCurrentStep] = useState(0)
  const Component = steps[currentStep]?.component

  const handleClose = () => {
    setOpenDialog(false)
    markViewed.welcomeModal()
  }

  const goToPreviousPage = () => {
    setAnimationDirection(-1)
    setCurrentStep(prev => prev - 1)
  }

  const goToNextPage = () => {
    setAnimationDirection(1)
    setCurrentStep(prev => prev + 1)
  }

  if (!offerLetter) return null

  if (isSmDown) {
    return (
      <Sheet open={openDialog}>
        <SheetContent
          height={100}
          className={clsx("max-w-none bg-surface-100 !p-0 transition-all", {
            "!h-[476px] rounded-t-2xl":
              steps[currentStep].id === OnboardingStepId.getStarted,
          })}
        >
          <SheetBody
            className={clsx(
              "relative flex h-full grow flex-col justify-between overflow-x-hidden bg-white p-0",
              {
                "rounded-t-2xl":
                  steps[currentStep].id === OnboardingStepId.getStarted,
              }
            )}
          >
            {steps[currentStep] && (
              <Animation
                id={`page-${currentStep}`}
                direction={animationDirection}
                className="h-full"
              >
                <Component
                  offerLetter={offerLetter}
                  key={steps[currentStep]?.id}
                  goToNextPage={goToNextPage}
                  handleClose={handleClose}
                  isMini={isSmDown}
                />
              </Animation>
            )}
            {steps[currentStep].id !== OnboardingStepId.getStarted && (
              <div className="sticky bottom-0 z-1 mt-2 flex flex-col items-center justify-between gap-1 !border-0 bg-white p-3">
                <CurrentStepIndicator
                  stepsCount={steps.length}
                  currentStep={currentStep}
                  className="mb-1"
                />
                <Button
                  color="black"
                  className="w-full"
                  onClick={
                    currentStep === steps.length - 1
                      ? handleClose
                      : goToNextPage
                  }
                >
                  {currentStep === steps.length - 1 ? "Finish" : "Next"}
                </Button>
              </div>
            )}
          </SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={openDialog}>
      <DialogContent className="rounded-2xl">
        <DialogBody className="overflow-x-hidden p-0">
          {steps[currentStep] && (
            <Animation
              id={`page-${currentStep}`}
              direction={animationDirection}
            >
              <Component
                offerLetter={offerLetter}
                key={steps[currentStep]?.id}
                goToNextPage={goToNextPage}
                handleClose={handleClose}
                isMini={isSmDown}
              />
            </Animation>
          )}
        </DialogBody>
        {steps[currentStep].id !== OnboardingStepId.getStarted && (
          <DialogFooter className="flex items-center justify-between !border-0 p-3">
            <Button
              variant="text"
              color="black"
              onClick={goToPreviousPage}
              startAdornment={<NavArrowLeft />}
            >
              Back
            </Button>
            <div>
              <CurrentStepIndicator
                stepsCount={steps.length}
                currentStep={currentStep}
              />
            </div>
            <Button
              color="black"
              onClick={
                currentStep === steps.length - 1 ? handleClose : goToNextPage
              }
            >
              {currentStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default PgCTLWelcomeOnboardingDialog
